import { apiPost } from "../baseApi";
import { setIdp } from "service/mapper";

export const directorySync = async ({ data = {}, id = null, config = {} }) => {
  try {
    const response = await apiPost("_directorySync", data, null, config);
    // An error answer has no district: keep its message for the error dialog
    if (response?.error) return response;
    return { ...response, data: setIdp(response?.data?.data?.idp_detail) };
  } catch (error) {
    return Promise.reject(error);
  }
};
